import doLog from '@/common/log';
import DrawerStore from '@/stores/drawer';
import Alitalk from '@alife/icbu-alitalk-react';
import React from 'react';

export default function Chat({ i18n, productId, productOwnMemberAlitalkEncryptId }: {
  productOwnMemberAlitalkEncryptId: string
  productId: string
  i18n: DetailTypes.i18n
}) {
  const { dialogShow } = DrawerStore(state => state);
  // 场景来源参数
  const scene = {
    fromPage: 'product_detail',
    bizType: 'chat_now',
    bucket: '',
  };

  return (
    <div className='bottom-button'>
      <Alitalk
        uid={productOwnMemberAlitalkEncryptId}
        pid={productId}
        bizType="1"
        bizId={productId}
        action="chatNow"
        sceneType="detail"
        scene={scene} // 场景来源参数
      >
        <div className="order-button">
          <button onClick={e => {
            e.preventDefault();
            doLog('/sc.details.chat');
            dialogShow(({
              type: 'product'
            }))
          }}>{i18n['rightAction.chat']}</button></div>
      </Alitalk>
    </div >
  )
}
